import css from "./assets/css/desktop-promo.module.css";
import balenciagaLogo from "./assets/images/balenciaga.png";
import { useEffect, useState } from "react";

// Import static QR code images
import defaultQRCode from "./assets/images/qr-code.png";
import qrCodeA from "./assets/images/qr-code-a.png";
import qrCodeB from "./assets/images/qr-code-b.png";
import qrCodeC from "./assets/images/qr-code-c.png";

const DesktopPromo = () => {
  const [qrCodeImage, setQRCodeImage] = useState(defaultQRCode);

  useEffect(() => {
    // Extract the 'lens' parameter from the URL
    const params = new URLSearchParams(window.location.search);
    const lensParam = params.get("lens");

    // Determine the QR code image based on the lens parameter
    switch (lensParam) {
      case "a":
        setQRCodeImage(qrCodeA);
        break;
      case "b":
        setQRCodeImage(qrCodeB);
        break;
      case "c":
        setQRCodeImage(qrCodeC);
        break;
      default:
        setQRCodeImage(defaultQRCode);
    }
  }, []);

  return (
    <div className={css.desktopPromoContainer}>
      {/* <div className={css.desktopPromoHeader}>
                <img src={balenciagaLogo} alt="Balenciaga Logo" />
            </div>
            <div className={css.desktopPromoCenteredBox}>
                <div className={css.desktopPromoQRCode} style={{ backgroundImage: `url(${qrCodeImage})` }}></div>
                <span className={css.desktopPromoTitle}>SCAN QR-CODE TO ACCESS THE FILTER</span>
                <span className={css.desktopPromoSubTitle}>Use Safari on iOS and Chrome on Android</span>
            </div> */}
      <div className={css.desktopPromoContent}>
        <div
          className={css.desktopPromoQRCode}
          style={{ backgroundImage: `url(${qrCodeImage})` }}
        ></div>
        <p className={css.desktopPromoTitle}>
          Scan with your smartphone
        </p>
        <p className={css.desktopPromoTitle}>
          camera to try-on
        </p>
      </div>
    </div>
  );
};

export default DesktopPromo;
